import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";

interface GiftBoxAnimationProps {
    onFinish: () => void;
    text: string;
}

const GiftBoxAnimation: React.FC<GiftBoxAnimationProps> = ({ onFinish, text }) => {
    const [showWelcomeText, setShowWelcomeText] = useState(false);
    const [animationData, setAnimationData] = useState<any>(null);

    useEffect(() => {
        fetch("/assets/admin/gift-box-loading-animation.json")
            .then((res) => res.json())
            .then(setAnimationData)
            .catch((err) => console.error("Failed to load Lottie JSON", err));
    }, []);

    useEffect(() => {
        const showTextTimer = setTimeout(() => {
            setShowWelcomeText(true);
        }, 9200);

        const completeTimer = setTimeout(() => {
            setShowWelcomeText(false);
            onFinish();
        }, 14000);

        return () => {
            clearTimeout(showTextTimer);
            clearTimeout(completeTimer);
        };
    }, [onFinish]);

    if (!animationData) return null;

    return (
        <div className="w-screen h-screen fixed inset-0 bg-white  flex items-center justify-center z-50">
            <Lottie
                animationData={animationData}
                loop={false}
                className="w-full h-full"
            />
            {showWelcomeText && (
                <motion.div
                    className="fixed inset-0 flex items-center justify-center z-50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1 }}
                >
                    <h1 className="text-3xl font-bold text-center text-green-700">
                        {text}
                    </h1>
                </motion.div>
            )}
        </div>
    );
};

export default GiftBoxAnimation;
